// function that takes in an array of vertices and returns true if the first and last vertices are the same
export const isPolygonClosed = (vertices) => {
    if (vertices.length <= 2) {
        return false;
    }
    const firstVertex = vertices[0];
    const lastVertex = vertices[vertices.length - 1];
    return firstVertex[0] === lastVertex[0] && firstVertex[1] === lastVertex[1];
};
//# sourceMappingURL=isPolygonClosed.js.map